import { render, staticRenderFns } from "./printPurReturn.vue?vue&type=template&id=0e7ec704&scoped=true&"
import script from "./printPurReturn.vue?vue&type=script&lang=js&"
export * from "./printPurReturn.vue?vue&type=script&lang=js&"
import style0 from "./printPurReturn.vue?vue&type=style&index=0&id=0e7ec704&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7ec704",
  null
  
)

component.options.__file = "printPurReturn.vue"
export default component.exports